// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Afkc","header":"ReportDetails_header__1UNK4","title":"ReportDetails_title__3kkQF","left":"ReportDetails_left__3kf_J"};